export const DANA_GOLDEN_MINUTE_DEBUG_TOOLS = 'dana_golden_minute_debug_tools';
export const FORCEBI = 'forcebi';
export const CROSS_FILTERS = 'cross_filters';
export const AUTOMATIONS_SETTINGS = 'automations_settings';
export const COPILOT_SIDEBAR = 'copilot_sidebar';
export const MULTIENVIRONMENT_ENTITIES2 = 'multienvironment_entities2';
export const SAGE_STATUS_WIDGET = 'sage_status_widget';
export const COPILOT_BAR = 'copilot_bar';
export const COPILOT_BAR_LIVE = 'copilot_bar_live';
export const SPAMCHIMP = 'spamchimp';
